// extracted by mini-css-extract-plugin
module.exports = {"container":"_32726725","isMobile":"_55db3458"};